import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      es: {
        translation: {
          noCreditsLeft: "No tienes créditos disponibles",
          login: "Iniciar sesión",
          sendingData: "Enviando datos",
          notObjectProcessed: "No se han podido procesar los siguientes objetos:\n",
          company: "Compañía",
          contact: "Contacto",
          deal: "Negocio",
          task: "Tarea",
          meeting: "Reunión",
          mail: "Correo",
          contacts: "Contactos",
          note: "Nota",
          call: "Llamada",
          pipeline: "Pipeline",
          pipelineStages: "Etapas",
          other: "Otro",
          selectPipeline: "Seleccione un pipeline",
          selectPipelineStage: "Seleccione una etapa",
          validateCompany: "Valide los datos de la compañía",
          validateContact: "Valide los datos del contacto",
          validateTask: "Valide los datos de la tarea",
          validateMeeting: "Valide los datos de la reunión",
          validateMail: "Valide los datos del correo",
          validateNote: "Valide los datos de la nota",
          validateCall: "Valide los datos de la llamada",
          validateDeal: "Valide los datos del negocio",
          validateEmail: "Valide los datos del correo electrónico",
          voiceInput: "Dictar con voz",
          stopRecording: "Detener grabación",
          voiceProcessing: "Procesando voz...",
          voiceError: "Error al grabar",
          makeShorter: "Más corto",
          makeProfessional: "Profesional",
          addUrgency: "Urgencia",
          makeFriendly: "Amigable",
          tasks: "Tareas",
          next: "Siguiente",
          finish: "Finalizar",
          cancel: "Cancelar",
          cancelConfirmation: "¿Estás seguro de que quieres cancelar?",
          discardChanges: "Descartar cambios",
          stay: "Quedarse",
          discard: "Descartar",
          close: "Cerrar",
          ok: "Ok",
          errorProcessingRequest: "Error al procesar la solicitud",
          errorProcessingRequestDescription: "Inténtelo de nuevo.",
          processing: "Procesando...",
          processingAudio: "Procesando audio",
          minutesSaved: "Has ahorrado",
          minutes: "minutos",
          savedIn: "en",
          audioSentCorrectly: "Audio enviado correctamente",
          retry: "Reintentar",
          dateTime: "Fecha y hora",
          duration: "Duración",
          disposition: "Resultado",
          busy: "Ocupado",
          connected: "Conectado",
          noResponse: "No respondió",
          wrongNumber: "Número incorrecto",
          voiceMessage: "Dejó mensaje de voz",
          liveMessage: "Dejó mensaje en vivo",
          direction: "Dirección",
          inbound: "ENTRANTE",
          outbound: "SALIENTE",
          title: "Título",
          audioText: "Pulsa para grabar",
          description: "Descripción",
          associations: "Asociaciones",
          companies: "Empresas",
          deals: "Negocios",
          companyName: "Nombre de la compañía",
          companyDomain: "Dominio de la compañía",
          selectCompany: "Selecciona una compañía",
          createCompany: "Crear compañía",
          errorSendingAudio: "Error al enviar el audio",
          createCompanyDescription: "Crea una nueva compañía",
          userAlreadyExists: "Sucedió un error, por favor compruebe los datos y vuelva a intentarlo",
          name: "Nombre",
          lastName: "Apellidos",
          email: "Email",
          phoneNumber: "Teléfono",
          selectContact: "Selecciona un contacto",
          createContact: "Crear contacto",
          dealName: "Nombre del negocio",
          dealValue: "Valor del negocio",
          dealClose: "Fecha de cierre del negocio",
          selectDeal: "Selecciona un negocio",
          recipients: "Destinatarios",
          addRecipient: "Agregar destinatario",
          attachments: "Adjuntos",
          uploadAttachment: "Subir archivo",
          uploadingAttachment: "Subiendo archivo...",
          recentAttachments: "Archivos recientes",
          noRecentAttachments: "No hay archivos recientes",
          attachmentUploadFailed: "No se pudo subir el archivo adjunto",
          emailInvalidHint: "Email no válido. Transcripción: '{{value}}'. Edita para corregirlo.",
          subject: "Asunto",
          message: "Mensaje",
          meetingTitle: "Título de la reunión",
          meetingStartDate: "Fecha de inicio",
          meetingEndDate: "Fecha de finalización",
          meetingLocation: "Lugar",
          meetingReminder: "Recordatorio",
          meetingDescription: "Descripción",
          meetingInternalNote: "Nota interna",
          low: "Baja",
          medium: "Media",
          high: "Alta",
          dueDate: "Fecha de vencimiento",
          hsTaskType: "Tipo de tarea",
          call: "Llamada",
          email: "Correo electrónico",
          todo: "Tarea",
          crmUpdated: "CRM actualizado correctamente",
          domain: "Dominio",
          phone: "Teléfono",
          address: "Dirección",
          audioCompanyText: "Pulsa para grabar acciones sobre esta compañía",
          errorMovingDeal: "Error al mover el negocio. Por favor, inténtalo de nuevo más tarde.",
          selectStage: "Selecciona a que etapa del pipeline quieres pasar este negocio.",
          moveDeal: "Mover a otra etapa",
          dealMoved: "Negocio movido correctamente",
          noDealsFound: "No se encontraron negocios",
          kanban: "Kanban",
          closingSoon: "Pronto",
          noDealsInStage: "—",
          noContactsFound: "No se encontraron contactos",
          noCompaniesFound: "No se encontraron empresas",
          noTasksFound: "No se encontraron tareas",
          filterPipeline: "Filtrar por pipeline",
          save: "Guardar",
          stage: "Etapa",
          amount: "Importe",
          closedate: "Fecha de cierre",
          createdate: "Fecha de creación",
          audioContactText: "Habla: edita campos, asocia empresa, crea tareas, notas, deals, emails, llamadas o reuniones",
          record: "Grabar",
          account: "Cuenta",
          recording: "Grabando audio...",
          paused: "Pausado",
          microphone: "Micrófono",
          recordingCancelled: "Grabación cancelada",
          clearRecording: "Limpiar grabación",
          resumeRecording: "Reanudar grabación",
          selectMicrophone: "Seleccionar micrófono",
          recordAgain: "Grabar de nuevo",
          cancel: "Cancelar",
          close: "Cerrar",
          done: "Hecho",
          search: "Buscar",
          min: "min",
          sortBy: "Ordenar por",
          newest: "Más nuevo",
          oldest: "Más antiguo",
          disconnectGmail: "Desconectar Gmail",
          logout: "Cerrar sesión",
          connectGmail: "Conectar Gmail",
          gmailConnected: "Gmail conectado correctamente",
          gmailDisconnected: "Gmail desconectado correctamente",
          attendees: "Asistentes",
          properties: "Propiedades",
          select_properties: "Seleccione propiedades",
          propertyToUpdate: "Propiedad a actualizar",
          selectProperty: "Seleccione propiedades",
          updateProperties: "Actualizar propiedades",
          propertiesUpdated: "Propiedades actualizadas correctamente",
          propertiesUpdatedError: "Error al actualizar las propiedades",
          objectType: "Tipo de objeto",
          selectProperties: "Seleccione propiedades",
          search_properties: "Buscar propiedades",
          noPropertiesSelected: "No se han seleccionado propiedades para configurar.",
          configureProperties: "Configurar propiedades",
          mandatory: "Obligatorio",
          mandatoryIf: "Obligatorio si",
          globalProperties: "Propiedades globales del negocio",
          stageProperties: "Propiedades de la etapa",
          loadingProperties: "Cargando propiedades...",
          currentStage: "Etapa actual",
          selectPipelineForProps: "Pipeline",
          selectStageForProps: "Etapa",
          selectPipelineFirst: "Seleccione un pipeline primero",
          selectStageFirst: "Seleccione una etapa para configurar propiedades específicas",
          remove: "Eliminar",
          createGoogleMeet: "Enviar enlace de Google Meet",
          createMeeting: "Enviar convocatoria de reunión al cliente",
          completed: "Completado",
          not_started: "No iniciado",
          none: "Sin prioridad",
          reminders: "Recordatorios",
          nearest: "Más próximo",
          farthest: "Más lejano",
          updateTask: "Actualizar tarea",
          status: "Estado",
          notStarted: "No iniciado",
          inProgress: "En progreso",
          errorUpdatingTask: "Error al actualizar la tarea",
          priority: "Prioridad",
          type: "Tipo",
          identifyingActions: "Identificando acciones",
          welcomeToLabia: "Bienvenido a Labia",
          onboardingDescription: "Descubre lo que puedes hacer con Labia a través de estos ejemplos. ¡Haz clic en 'Pruébalo' para ver cómo funciona!",
          onboardingExamplesCarousel: "Ejemplos de incorporación",
          slideXofY: "Diapositiva {{current}} de {{total}}",
          goToSlide: "Ir a la diapositiva {{number}}",
          previousSlide: "Diapositiva anterior",
          nextSlide: "Diapositiva siguiente",
          example: "Ejemplo",
          tryIt: "Pruébalo",
          showMore: "Mostrar más",
          showLess: "Mostrar menos",
          learnToUseLabia: "Descubre qué puedes hacer con Labia",
          discoverLabia: "Descubre qué puedes hacer",
          onboarding: "¿Quieres aprender a usar Labia?",
          onboardingExamples: {
            contactAndCompany: {
              title: "Crear Contactos y Empresas",
              description: "Crea fácilmente nuevos contactos y empresas con todos sus detalles en lenguaje natural.",
              example: "Labia, creame un contacto llamado Daniel Rodriguez de la empresa Labia con el email dani@labia.pro y el teléfono 678368027. Crea la compañía Labia con el dominio labia.pro",
            },
            dealsPipeline: {
              title: "Crear Negocios en el pipeline de ventas",
              description: "Crea negocios en el pipeline de ventas para hacer seguimiento de la información importante.",
              example: "Crea un negocio por valor de 5000 euros con el nombre \"Paquete 100 unidades\" y una fecha de cierre estimada para el 20 de junio.",
            },
            tasksAndNotes: {
              title: "Crear Tareas y Notas",
              description: "Programa tareas y añade notas para hacer seguimiento de información importante y cerrar más ventas.",
              example: "Busca al contacto Daniel Rodríguez y crea una tarea para llamarle el viernes a las 10 de la mañana para comprobar si ha podido ver nuestro catálogo y nuestra oferta. Crea además una nota interna exponiendo que es el director de compras, es celíaco  y le gusta el Real Madrid."
            },
            email: {
              title: "Enviar emails",
              description: "Envía Emails personalizados y con el tono de tu empresa",
              example: "Envíale un email a Daniel Rodríguez con tono emocionado diciendo que ya he probado Labia, me ha parecido increíble y me ahorrará mucho tiempo, añádele iconos."
            },
            meeting: {
              title: "Agenda reuniones",
              description: "Agenda reuniones con clientes y enviales la convocatoria de la reunión",
              example: "Agenda una reunión con Daniel Rodríguez para el 15 de junio a las 12  en sus oficinas de Madrid con el Asunto: \"Reunión Demo\", donde hablaremos sobre nuestro nuevo producto."
            },
            call: {
              title: "Llamadas",
              description: "Registra llamadas con el resumen de lo conversado con el cliente",
              example: "Registra una llamada con el contacto Daniel Rodríguez hace 10 minutos donde hemos hablado sobre el presupuesto que le ha enviado la competencia y me ha comentado que si le hacemos un 10% de descuento lo firma esta misma tarde."
            },
            allInOne: {
              title: "Todas las acciones en una sola instrucción",
              description: "Crea un contacto, una tarea, una nota y un email con una sola instrucción.",
              example: "Creame un contacto llamado Carmen Rodriguez Pérez de la empresa CRM con el email carmen@crm.com y el teléfono 611223344. Crea la compañía CRM con el dominio CRM.com\n\nCrea una tarea para llamarle el viernes a las 10 de la mañana y comentarle que ya he aumentado mis ventas gracias a la mejor gestión del CRM.\n\nCrea además una nota interna del contacto exponiendo que es la directora de la empresa y es la encargada de recibir sugerencias de los clientes.\n\nPor último, envíale un email con tono emocionado diciendo que ya he probado su herramienta, me ha parecido increíble y me ahorrará mucho tiempo, añádele iconos."
            }
          },
          audioHistory: "Historial",
          audioStatusEmpty: "Sin transcripción",
          audioStatusDraft: "Sin ejecutar",
          loading: "Cargando...",
          noAudioHistory: "No hay historial de audio disponible",
          selectCamera: "Seleccionar cámara",
          capturePhoto: "Capturar foto",
          capturing: "Capturando...",
          errorProcessingPhoto: "Error al procesar la foto",
          ocrResult: "Texto detectado",
          ocr: "Escanear documento",
          businessCard: "Escanear tarjeta de visita",
          errorPageTitle: "Algo salió mal",
          errorPageDescription: "Ha ocurrido un error inesperado. Puedes volver al inicio o intentar recargar la página.",
          errorPageNotFound: "Página no encontrada",
          errorPageNotFoundDescription: "La página que buscas no existe o ha sido movida.",
          errorPageGoHome: "Ir al inicio",
          validationStepError: "No se pudo cargar este paso. Puedes omitirlo y continuar con el resto del proceso.",
          skipStep: "Omitir este paso",
          requiredFields: "Campos obligatorios",
          optionalFields: "Opcionales",
          required: "Obligatorio",
          step: "paso",
          endBeforeStart: "La fecha de finalización es anterior a la de inicio",
          newContact: "Nuevo contacto",
          existingContact: "Contacto existente",
          editing: "Editando",
          saveChanges: "Guardar cambios",
          selectExisting: "Seleccionar existente",
          createNew: "Crear nuevo",
          contactModeEdit: "Editar",
          contactModeCreate: "Crear",
          contactModeSelect: "Seleccionar",
          contactModeEditHelp: "Actualizarás los datos de {{name}} en HubSpot",
          contactModeCreateHelp: "Se creará un contacto nuevo",
          contactModeSelectHelp: "Se vinculará a {{name}} sin cambiar sus datos",
          newCompany: "Nueva empresa",
          existingCompany: "Empresa existente",
          meetingDate: "Fecha",
          startTime: "Hora inicio",
          meetingDuration: "Duración",
          endsAt: "Termina a las",
          durationMinutes: "Duración (min)",
          mandatoryField: "Campo obligatorio",
          list: "Lista",
          calendar: "Calendario",
          tapToSelect: "Toca para seleccionar",
          deselect: "Deseleccionar",
          filters: "Filtros",
          dayView: "Día",
          weekView: "Semana",
          monthView: "Mes",
          noTasksOnDay: "Sin tareas este día",
          noPriority: "Sin prioridad",
          goBack: "Volver",
          all: "Todo",
          dueToday: "Vencen hoy",
          overdue: "Vencida",
          week: "Semana",
          month: "Mes",
          noDate: "Sin fecha",
          today: "Hoy",
          tomorrow: "Mañana",
          yesterday: "Ayer",
          selected: "selec.",
          selectAll: "Selec. todo",
          dateRange: "Filtro de fecha",
          complete: "Completar",
          markComplete: "Completar",
          reschedule: "Reprogramar",
          rescheduleDescription: "Selecciona la nueva fecha",
          rescheduleTaskDescription: "Selecciona la nueva fecha para esta tarea",
          newDate: "Nueva fecha",
          tasksUpdated: "Tareas actualizadas",
          taskUpdated: "Tarea actualizada",
          overdueTask: "Vencida",
          updateTaskDescription: "Actualiza los detalles de la tarea",
          errorSavingProperties: "Error al guardar las propiedades. Inténtalo de nuevo.",
          selectPipelineAndStageFirst: "Seleccione un pipeline y una etapa primero",
          noneCondition: "Sin condición",
          propertiesIntroTitle: "Configura lo que la IA extrae de tu voz",
          propertiesIntroDescription: "Selecciona las propiedades de tu CRM que la IA debe rellenar cuando hablas. Marca las obligatorias para que siempre se te pida confirmación.",
          propertiesIntroTip: "Consejo: Usa \"Obligatorio si\" para vincular campos relacionados. Por ejemplo, haz \"Ciudad\" obligatorio solo si \"Dirección\" está presente.",
          gotIt: "Entendido",
          propertyType: "Tipo",
          propertiesEmptyHint: "Busca y añade propiedades usando el campo de arriba.",
          stageEmptyHint: "Selecciona un pipeline y etapa arriba para configurar propiedades específicas por etapa.",
          voiceUpdate: "Actualización por voz",
          additionalDetails: "Detalles adicionales",
          audioDealText: "Pulsa para actualizar este negocio",
          contactInfo: "Información",
          sendEmail: "Email",
          callContact: "Llamar",
          audioEmailText: "Dicta el correo que quieres enviar",
          industry: "Industria",
          employees: "Empleados",
          annualRevenue: "Ingresos anuales",
          associatedContacts: "Contactos asociados",
          associatedDeals: "Negocios asociados",
          noAssociatedContacts: "Sin contactos asociados",
          noAssociatedDeals: "Sin negocios asociados",
          companyInfo: "Información de la compañía",
          selectAssociations: "Asociar entidades",
          missingAssociations: "Selecciona contactos o empresas para asociar",
          resend: "Reenviar",
          edit: "Editar",
          tryExampleHint: "Prueba diciendo algo como...",
          almostReady: "Casi listo...",
          createdSuccessfully: "¡Creado correctamente!",
          recordAnother: "Grabar otro",
          review: "Revisión",
          actionsToCreate: "{{count}} acciones se crearán",
          confirmAndSend: "Confirmar y enviar",
          addAction: "Añadir acción",
          speakToAddMore: "Habla para añadir más",
          draftFound: "Borrador encontrado",
          resumeDraft: "Continuar",
          discardDraft: "Descartar",
          liveTranscript: "Transcripción en vivo",
          followUpWith: "Seguimiento con {{name}}",
          associationsPreview: "Asociaciones",
          willBeLinked: "se vinculará con",
          flowContact: "Contacto del flujo",
          flowCompany: "Empresa del flujo",
          expressMode: "Express",
          expressDescription: "Valida todo antes de revisar",
          oneShotSuccess: "Datos extraídos correctamente. Revisa y confirma.",
          estimatedCloseDate: "Fecha estimada de cierre",
          dealOwner: "Responsable del negocio",
          firstName: "Nombre",
          taskType: "Tipo de tarea",
          startDate: "Fecha de inicio",
          endTime: "Hora de fin",
          location: "Ubicación",
          internalNote: "Nota interna",
          emailSubject: "Asunto del correo",
          emailMessage: "Mensaje del correo",
          sender: "Remitente",
          callTitle: "Título de la llamada",
          date: "Fecha",
          details: "Detalles",
          internalNotes: "Notas internas",
          createCalendarEvent: "Crear evento en calendario",
          validatingData: "Validando datos...",
          validating: "Validando",
          analyzingContent: "Analizando contenido",
          extractingEntities: "Extrayendo entidades",
          searchingCRM: "Buscando en CRM",
          processingComplete: "Procesamiento completo",
          propertyAssistant: "Asistente IA",
          propertyChatTitle: "Configurar propiedades",
          propertyChatWelcome: "Soy tu asistente de configuración de propiedades CRM. Descríbeme tu negocio y te recomendaré qué campos configurar como obligatorios para cada tipo de objeto (contactos, negocios, tareas, etc.). También puedes usar la pestaña Manual para configurar directamente.",
          propertyChatDailyIntroBadge: "Intro IA diaria",
          propertyChatDailyIntroToday: "Actualizado hoy para tu empresa",
          propertyChatDailyIntroCached: "Reutilizando contexto previo de tu empresa",
          propertyChatPlaceholder: "Describe tu negocio o pregunta sobre propiedades...",
          chatPrompt1: "Somos una agencia inmobiliaria",
          chatPrompt2: "Startup SaaS, ventas B2B",
          chatPrompt3: "Consultora de servicios profesionales",
          applyConfiguration: "Aplicar",
          modifyConfiguration: "Modificar",
          applying: "Aplicando...",
          configTimeout: "Tiempo de espera agotado. Reintenta.",
          configApplied: "Configuración aplicada correctamente",
          configFailed: "Error al aplicar la configuración",
          aiSuggestion: "Sugerencia IA",
          propertiesFor: "propiedades",
          propertySingular: "propiedad",
          propertyPlural: "propiedades",
          deal_stage: "etapa de negocio",
          mandatoryBadge: "Obligatorio",
          optionalBadge: "Opcional",
          conditional: "Condicional",
          chatTab: "Asistente IA",
          manualTab: "Manual",
          addProperty: "Añadir propiedad",
          searchAndAddProperty: "Buscar y agregar propiedad...",
          propertyType_string: "Texto",
          propertyType_number: "Número",
          propertyType_date: "Fecha",
          propertyType_datetime: "Fecha/Hora",
          propertyType_enumeration: "Lista",
          propertyType_bool: "Sí/No",
          propertyType_phone_number: "Teléfono",
          saveProperties: "Guardar",
          selectObjectType: "Seleccionar tipo de objeto",
          companyProfile: "Perfil de empresa",
          writingTone: "Tono de escritura",
          configureInAssistant: "Configurar en el Asistente IA →",
          writingStyle: "Estilo de escritura",
          trainedOnEmails: "Entrenado con {{count}} correos",
          autoUpdates: "Se actualiza automáticamente con cada correo enviado",
          profileUpdated: "Perfil actualizado"
        }
      },
      pt: {
        translation: {
          noCreditsLeft: "Sem créditos disponíveis",
          login: "Iniciar sessão",
          sendingData: "Enviando dados",
          notObjectProcessed: "Não foi possível processar os seguintes objetos:\n",
          audioText: "Pulsa para gravar",
          company: "Empresa",
          contact: "Contato",
          contacts: "Contactos",
          deal: "Negócio",
          task: "Tarefa",
          meeting: "Reunião",
          mail: "E-mail",
          note: "Nota",
          call: "Chamada",
          pipeline: "Pipeline",
          pipelineStages: "Etapas",
          other: "Outro",
          tasks: "Tarefas",
          selectPipeline: "Selecione um pipeline",
          selectPipelineStage: "Selecione uma etapa",
          validateCompany: "Valide os dados da empresa",
          validateContact: "Valide os dados do contato",
          validateTask: "Valide os dados da tarefa",
          validateMeeting: "Valide os dados da reunião",
          validateMail: "Valide os dados do e-mail",
          validateNote: "Valide os dados da nota",
          validateCall: "Valide os dados da chamada",
          validateDeal: "Valide os dados do negócio",
          validateEmail: "Valide os dados do e-mail",
          voiceInput: "Entrada por voz",
          stopRecording: "Parar gravação",
          voiceProcessing: "Processando voz...",
          voiceError: "Erro de gravação",
          makeShorter: "Mais curto",
          makeProfessional: "Profissional",
          addUrgency: "Urgência",
          makeFriendly: "Amigável",
          next: "Próximo",
          finish: "Finalizar",
          cancel: "Cancelar",
          cancelConfirmation: "Tem certeza que deseja cancelar?",
          discardChanges: "Descartar alterações",
          stay: "Ficar",
          discard: "Descartar",
          close: "Fechar",
          ok: "Ok",
          errorProcessingRequest: "Erro ao processar a solicitação",
          errorProcessingRequestDescription: "Tente novamente.",
          errorSendingAudio: "Erro ao enviar o áudio",
          processing: "Processando...",
          processingAudio: "Processando áudio",
          minutesSaved: "Você economizou",
          minutes: "minutos",
          min: "min",
          savedIn: "em",
          audioSentCorrectly: "Áudio enviado corretamente",
          retry: "Tentar novamente",
          dateTime: "Data e hora",
          duration: "Duração",
          disposition: "Resultado",
          busy: "Ocupado",
          connected: "Conectado",
          noResponse: "Sem resposta",
          wrongNumber: "Número incorreto",
          voiceMessage: "Deixou mensagem de voz",
          liveMessage: "Deixou mensagem ao vivo",
          direction: "Direção",
          inbound: "ENTRADA",
          outbound: "SAÍDA",
          title: "Título",
          description: "Descrição",
          associations: "Associações",
          companies: "Empresas",
          deals: "Negócios",
          companyName: "Nome da empresa",
          companyDomain: "Domínio da empresa",
          selectCompany: "Selecione uma empresa",
          createCompany: "Criar empresa",
          createCompanyDescription: "Crie uma nova empresa",
          userAlreadyExists: "Ocorreu um erro, por favor verifique os dados e tente novamente",
          name: "Nome",
          lastName: "Sobrenome",
          email: "E-mail",
          phoneNumber: "Telefone",
          selectContact: "Selecione um contato",
          createContact: "Criar contato",
          dealName: "Nome do negócio",
          dealValue: "Valor do negócio",
          dealClose: "Data de fechamento do negócio",
          selectDeal: "Selecione um negócio",
          recipients: "Destinatários",
          addRecipient: "Adicionar destinatário",
          attachments: "Anexos",
          uploadAttachment: "Enviar arquivo",
          uploadingAttachment: "Enviando arquivo...",
          recentAttachments: "Arquivos recentes",
          noRecentAttachments: "Sem arquivos recentes",
          attachmentUploadFailed: "Não foi possível enviar o anexo",
          emailInvalidHint: "Email inválido. Transcrição: '{{value}}'. Edite para corrigir.",
          subject: "Assunto",
          message: "Mensagem",
          meetingTitle: "Título da reunião",
          meetingStartDate: "Data de início",
          meetingEndDate: "Data de término",
          meetingLocation: "Local",
          meetingReminder: "Lembrete",
          meetingDescription: "Descrição",
          meetingInternalNote: "Nota interna",
          low: "Baixa",
          medium: "Média",
          high: "Alta",
          dueDate: "Data de vencimento",
          hsTaskType: "Tipo de tarefa",
          call: "Chamada",
          email: "E-mail",
          todo: "Tarefa",
          crmUpdated: "CRM atualizado corretamente",
          domain: "Domínio",
          phone: "Telefone",
          address: "Endereço",
          audioCompanyText: "Clique para gravar ações sobre esta empresa",
          errorMovingDeal: "Erro ao mover o negócio. Por favor, tente novamente mais tarde.",
          selectStage: "Selecione para qual etapa do pipeline você quer mover este negócio.",
          moveDeal: "Mover para outra etapa",
          dealMoved: "Negócio movido com sucesso",
          noDealsFound: "Nenhum negócio encontrado",
          kanban: "Kanban",
          closingSoon: "Em breve",
          noDealsInStage: "—",
          noContactsFound: "Nenhum contato encontrado",
          noCompaniesFound: "Nenhuma empresa encontrada",
          noTasksFound: "Nenhuma tarefa encontrada",
          filterPipeline: "Filtrar por pipeline",
          save: "Salvar",
          stage: "Etapa",
          amount: "Valor",
          closedate: "Data de fechamento",
          createdate: "Data de criação",
          audioContactText: "Fale: edite campos, associe empresa, crie tarefas, notas, deals, emails, chamadas ou reuniões",
          record: "Gravar",
          account: "Conta",
          recording: "Gravando áudio...",
          paused: "Pausado",
          microphone: "Microfone",
          recordingCancelled: "Gravação cancelada",
          clearRecording: "Limpar gravação",
          resumeRecording: "Retomar gravação",
          selectMicrophone: "Selecionar microfone",
          recordAgain: "Gravar novamente",
          cancel: "Cancelar",
          close: "Fechar",
          done: "Concluído",
          search: "Buscar",
          sortBy: "Ordenar por",
          newest: "Mais recente",
          oldest: "Mais antigo",
          disconnectGmail: "Desconectar Gmail",
          logout: "Sair",
          connectGmail: "Conectar Gmail",
          gmailConnected: "Gmail conectado corretamente",
          gmailDisconnected: "Gmail desconectado corretamente",
          attendees: "Participantes",
          properties: "Propriedades",
          select_properties: "Selecione propriedades",
          propertyToUpdate: "Propriedade a atualizar",
          selectProperty: "Selecione propriedades",
          updateProperties: "Atualizar propriedades",
          propertiesUpdated: "Propriedades atualizadas corretamente",
          propertiesUpdatedError: "Erro ao atualizar as propriedades",
          objectType: "Tipo de objeto",
          selectProperties: "Selecione as propriedades",
          search_properties: "Pesquisar propriedades",
          noPropertiesSelected: "Nenhuma propriedade selecionada para configurar.",
          configureProperties: "Configurar propriedades",
          mandatory: "Obrigatório",
          mandatoryIf: "Obrigatório se",
          globalProperties: "Propriedades globais do negócio",
          stageProperties: "Propriedades da etapa",
          loadingProperties: "Carregando propriedades...",
          currentStage: "Etapa atual",
          selectPipelineForProps: "Pipeline",
          selectStageForProps: "Etapa",
          selectPipelineFirst: "Selecione um pipeline primeiro",
          selectStageFirst: "Selecione uma etapa para configurar propriedades específicas",
          remove: "Remover",
          createGoogleMeet: "Enviar link do Google Meet",
          createMeeting: "Enviar convite de reunião ao cliente",
          not_started: "Não iniciado",
          none: "Sem prioridade",
          reminders: "Lembretes",
          nearest: "Mais próximo",
          farthest: "Mais distante",
          updateTask: "Atualizar tarefa",
          status: "Status",
          notStarted: "Não iniciado",
          inProgress: "Em andamento",
          completed: "Completado",
          errorUpdatingTask: "Erro ao atualizar a tarefa",
          priority: "Prioridade",
          type: "Tipo",
          identifyingActions: "Identificando ações",
          welcomeToLabia: "Bem-vindo ao Labia",
          onboardingDescription: "Descubra o que você pode fazer com o Labia através destes exemplos. Clique em 'Experimente' para ver como funciona!",
          onboardingExamplesCarousel: "Exemplos de integração",
          slideXofY: "Slide {{current}} de {{total}}",
          goToSlide: "Ir para o slide {{number}}",
          previousSlide: "Slide anterior",
          nextSlide: "Próximo slide",
          example: "Exemplo",
          tryIt: "Experimente",
          showMore: "Mostrar mais",
          showLess: "Mostrar menos", 
          learnToUseLabia: "Descubra o que você pode fazer com Labia",
          discoverLabia: "Descubra o que você pode fazer",
          onboarding: "Quer aprender a usar o Labia?",
          onboardingExamples: {
            contactAndCompany: {
              title: "Criar Contatos e Empresas",
              description: "Crie facilmente novos contatos e empresas com todos os seus detalhes em linguagem natural.",
              example: "Labia, crie um contato chamado Daniel Rodriguez da empresa Labia com o email dani@labia.pro e o telefone 678368027. Crie a empresa Labia com o domínio labia.pro",
            },
            dealsPipeline: {
              title: "Criar Negócios no pipeline de vendas",
              description: "Crie negócios no pipeline de vendas para acompanhar as informações importantes.",
              example: "Crie um negócio no valor de 5000 euros com o nome \"Pacote 100 unidades\" e uma data de fechamento estimada para 20 de junho.",
            },
            tasksAndNotes: {
              title: "Criar Tarefas e Notas",
              description: "Agende tarefas e adicione notas para acompanhar informações importantes e fechar mais vendas.",
              example: "Procure o contato Daniel Rodríguez e crie uma tarefa para ligar para ele na sexta-feira às 10 da manhã para verificar se ele pôde ver nosso catálogo e nossa oferta. Crie também uma nota interna explicando que ele é o diretor de compras, é celíaco e torce para o Real Madrid."
            },
            email: {
              title: "Enviar emails",
              description: "Envie Emails personalizados e com o tom da sua empresa",
              example: "Envie um email para Daniel Rodríguez com tom animado dizendo que já testei o Labia, achei incrível e vai me poupar muito tempo, adicione ícones."
            },
            meeting: {
              title: "Agendar reuniões",
              description: "Agende reuniões com clientes e envie o convite da reunião",
              example: "Agende uma reunião com Daniel Rodríguez para 15 de junho às 12h no escritório dele em Madrid com o Assunto: \"Reunião Demo\", onde falaremos sobre nosso novo produto."
            },
            call: {
              title: "Chamadas",
              description: "Registre chamadas com o resumo do que foi conversado com o cliente",
              example: "Registre uma chamada com o contato Daniel Rodríguez há 10 minutos onde conversamos sobre o orçamento que a concorrência enviou e ele me disse que se dermos 10% de desconto ele assina ainda hoje."
            },
            allInOne: {
              title: "Todas as ações em uma única instrução",
              description: "Crie um contato, uma tarefa, uma nota e um email com uma única instrução.",
              example: "Crie um contato chamado Carmen Rodriguez Pérez da empresa CRM com o email carmen@crm.com e o telefone 611223344. Crie a empresa CRM com o domínio CRM.com\n\nCrie uma tarefa para ligar para ela na sexta-feira às 10 da manhã e comentar que já aumentei minhas vendas graças à melhor gestão do CRM.\n\nCrie também uma nota interna do contato explicando que ela é a diretora da empresa e é responsável por receber sugestões dos clientes.\n\nPor último, envie um email com tom animado dizendo que já testei a ferramenta dela, achei incrível e vai me poupar muito tempo, adicione ícones."
            }
          },
          audioHistory: "Histórico de áudio",
          audioStatusEmpty: "Sem transcrição",
          audioStatusDraft: "Não executado",
          loading: "Carregando...",
          noAudioHistory: "Não há histórico de áudio disponível",
          selectCamera: "Selecionar câmara",
          capturePhoto: "Capturar foto",
          capturing: "Capturando...",
          errorProcessingPhoto: "Erro ao processar a foto",
          ocrResult: "Texto detectado",
          ocr: "Escanear documento",
          businessCard: "Escanear cartão de visita",
          errorPageTitle: "Algo deu errado",
          errorPageDescription: "Ocorreu um erro inesperado. Você pode voltar ao início ou tentar recarregar a página.",
          errorPageNotFound: "Página não encontrada",
          errorPageNotFoundDescription: "A página que você procura não existe ou foi movida.",
          errorPageGoHome: "Ir para o início",
          validationStepError: "Não foi possível carregar esta etapa. Você pode pular e continuar com o resto do processo.",
          skipStep: "Pular esta etapa",
          requiredFields: "Campos obrigatórios",
          optionalFields: "Opcionais",
          required: "Obrigatório",
          step: "passo",
          endBeforeStart: "A data de término é anterior à data de início",
          newContact: "Novo contacto",
          existingContact: "Contacto existente",
          editing: "Editando",
          saveChanges: "Salvar alterações",
          selectExisting: "Selecionar existente",
          createNew: "Criar novo",
          contactModeEdit: "Editar",
          contactModeCreate: "Criar",
          contactModeSelect: "Selecionar",
          contactModeEditHelp: "Você atualizará os dados de {{name}} no HubSpot",
          contactModeCreateHelp: "Um novo contato será criado",
          contactModeSelectHelp: "Será vinculado a {{name}} sem alterar os dados",
          newCompany: "Nova empresa",
          existingCompany: "Empresa existente",
          meetingDate: "Data",
          startTime: "Hora de início",
          meetingDuration: "Duração",
          endsAt: "Termina às",
          durationMinutes: "Duração (min)",
          mandatoryField: "Campo obrigatório",
          list: "Lista",
          calendar: "Calendário",
          tapToSelect: "Toque para selecionar",
          deselect: "Desmarcar",
          filters: "Filtros",
          dayView: "Dia",
          weekView: "Semana",
          monthView: "Mês",
          noTasksOnDay: "Sem tarefas neste dia",
          noPriority: "Sem prioridade",
          goBack: "Voltar",
          all: "Tudo",
          dueToday: "Vencem hoje",
          overdue: "Vencida",
          week: "Semana",
          month: "Mês",
          noDate: "Sem data",
          today: "Hoje",
          tomorrow: "Amanhã",
          yesterday: "Ontem",
          selected: "selec.",
          selectAll: "Selec. tudo",
          dateRange: "Filtro de data",
          complete: "Completar",
          markComplete: "Completar",
          reschedule: "Reagendar",
          rescheduleDescription: "Selecione a nova data",
          rescheduleTaskDescription: "Selecione a nova data para esta tarefa",
          newDate: "Nova data",
          tasksUpdated: "Tarefas atualizadas",
          taskUpdated: "Tarefa atualizada",
          overdueTask: "Vencida",
          updateTaskDescription: "Atualize os detalhes da tarefa",
          errorSavingProperties: "Erro ao salvar as propriedades. Tente novamente.",
          selectPipelineAndStageFirst: "Selecione um pipeline e uma etapa primeiro",
          noneCondition: "Sem condição",
          propertiesIntroTitle: "Configure o que a IA extrai da sua voz",
          propertiesIntroDescription: "Selecione as propriedades do CRM que a IA deve preencher quando você fala. Marque as obrigatórias para sempre confirmar.",
          propertiesIntroTip: "Dica: Use \"Obrigatório se\" para vincular campos relacionados. Por exemplo, torne \"Cidade\" obrigatório apenas se \"Endereço\" estiver presente.",
          gotIt: "Entendido",
          propertyType: "Tipo",
          propertiesEmptyHint: "Busque e adicione propriedades usando o campo acima.",
          stageEmptyHint: "Selecione um pipeline e etapa acima para configurar propriedades específicas por etapa.",
          voiceUpdate: "Atualização por voz",
          additionalDetails: "Detalhes adicionais",
          audioDealText: "Pressione para atualizar este negócio",
          contactInfo: "Informações",
          sendEmail: "Email",
          callContact: "Ligar",
          audioEmailText: "Dite o e-mail que deseja enviar",
          industry: "Indústria",
          employees: "Funcionários",
          annualRevenue: "Receita anual",
          associatedContacts: "Contatos associados",
          associatedDeals: "Negócios associados",
          noAssociatedContacts: "Sem contatos associados",
          noAssociatedDeals: "Sem negócios associados",
          companyInfo: "Informações da empresa",
          selectAssociations: "Associar entidades",
          missingAssociations: "Selecione contatos ou empresas para associar",
          resend: "Reenviar",
          edit: "Editar",
          tryExampleHint: "Tente dizer algo como...",
          almostReady: "Quase pronto...",
          createdSuccessfully: "Criado com sucesso!",
          recordAnother: "Gravar outro",
          review: "Revisão",
          actionsToCreate: "{{count}} ações serão criadas",
          confirmAndSend: "Confirmar e enviar",
          addAction: "Adicionar ação",
          speakToAddMore: "Fale para adicionar mais",
          draftFound: "Rascunho encontrado",
          resumeDraft: "Retomar",
          discardDraft: "Descartar",
          liveTranscript: "Transcrição ao vivo",
          followUpWith: "Acompanhar {{name}}",
          associationsPreview: "Associações",
          willBeLinked: "será vinculado a",
          flowContact: "Contato do fluxo",
          flowCompany: "Empresa do fluxo",
          expressMode: "Express",
          expressDescription: "Valida tudo antes de revisar",
          oneShotSuccess: "Dados extraídos corretamente. Revise e confirme.",
          estimatedCloseDate: "Data estimada de encerramento",
          dealOwner: "Responsável pelo negócio",
          firstName: "Nome",
          taskType: "Tipo de tarefa",
          startDate: "Data de início",
          endTime: "Hora de término",
          location: "Local",
          internalNote: "Nota interna",
          emailSubject: "Assunto do e-mail",
          emailMessage: "Mensagem do e-mail",
          sender: "Remetente",
          callTitle: "Título da chamada",
          date: "Data",
          details: "Detalhes",
          internalNotes: "Notas internas",
          createCalendarEvent: "Criar evento no calendário",
          validatingData: "Validando dados...",
          validating: "Validando",
          analyzingContent: "Analisando conteúdo",
          extractingEntities: "Extraindo entidades",
          searchingCRM: "Pesquisando no CRM",
          processingComplete: "Processamento concluído",
          propertyAssistant: "Assistente IA",
          propertyChatTitle: "Configurar propriedades",
          propertyChatWelcome: "Sou seu assistente de configuração de propriedades CRM. Descreva seu negócio e recomendarei quais campos configurar como obrigatórios para cada tipo de objeto (contatos, negócios, tarefas, etc.). Você também pode usar a aba Manual para configurar diretamente.",
          propertyChatDailyIntroBadge: "Intro IA diária",
          propertyChatDailyIntroToday: "Atualizado hoje para sua empresa",
          propertyChatDailyIntroCached: "Reutilizando contexto anterior da sua empresa",
          propertyChatPlaceholder: "Descreva seu negócio ou pergunte sobre propriedades...",
          chatPrompt1: "Somos uma agência imobiliária",
          chatPrompt2: "Startup SaaS, vendas B2B",
          chatPrompt3: "Consultora de serviços profissionais",
          applyConfiguration: "Aplicar",
          modifyConfiguration: "Modificar",
          applying: "Aplicando...",
          configTimeout: "Tempo de espera esgotado. Tente novamente.",
          configApplied: "Configuração aplicada com sucesso",
          configFailed: "Erro ao aplicar a configuração",
          aiSuggestion: "Sugestão IA",
          propertiesFor: "propriedades",
          propertySingular: "propriedade",
          propertyPlural: "propriedades",
          deal_stage: "etapa do negócio",
          mandatoryBadge: "Obrigatório",
          optionalBadge: "Opcional",
          conditional: "Condicional",
          chatTab: "Assistente IA",
          manualTab: "Manual",
          addProperty: "Adicionar propriedade",
          searchAndAddProperty: "Buscar e adicionar propriedade...",
          propertyType_string: "Texto",
          propertyType_number: "Número",
          propertyType_date: "Data",
          propertyType_datetime: "Data/Hora",
          propertyType_enumeration: "Lista",
          propertyType_bool: "Sim/Não",
          propertyType_phone_number: "Telefone",
          saveProperties: "Salvar",
          selectObjectType: "Selecionar tipo de objeto",
          companyProfile: "Perfil da empresa",
          writingTone: "Tom de escrita",
          configureInAssistant: "Configurar no Assistente IA →",
          writingStyle: "Estilo de escrita",
          trainedOnEmails: "Treinado com {{count}} e-mails",
          autoUpdates: "Atualiza automaticamente a cada e-mail enviado",
          profileUpdated: "Perfil atualizado"
        }
      },
      fr: {
        translation: {
          noCreditsLeft: "Vous n'avez plus de crédits disponibles",
          login: "Se connecter",
          sendingData: "Envoi des données",
          notObjectProcessed: "Les objets suivants n'ont pas pu être traités :\n",
          company: "Entreprise",
          contact: "Contact",
          deal: "Affaire",
          task: "Tâche",
          meeting: "Réunion",
          mail: "Courriel",
          contacts: "Contacts",
          note: "Note",
          call: "Appel",
          pipeline: "Pipeline",
          pipelineStages: "Étapes",
          other: "Autre",
          selectPipeline: "Sélectionnez un pipeline",
          selectPipelineStage: "Sélectionnez une étape",
          validateCompany: "Validez les données de l'entreprise",
          validateContact: "Validez les données du contact",
          validateTask: "Validez les données de la tâche",
          validateMeeting: "Validez les données de la réunion",
          validateMail: "Validez les données du courriel",
          validateNote: "Validez les données de la note",
          validateCall: "Validez les données de l'appel",
          validateDeal: "Validez les données de l'affaire",
          validateEmail: "Validez les données de l'e-mail",
          voiceInput: "Saisie vocale",
          stopRecording: "Arrêter l'enregistrement",
          voiceProcessing: "Traitement de la voix...",
          voiceError: "Erreur d'enregistrement",
          makeShorter: "Plus court",
          makeProfessional: "Professionnel",
          addUrgency: "Urgence",
          makeFriendly: "Amical",
          tasks: "Tâches",
          next: "Suivant",
          finish: "Terminer",
          cancel: "Annuler",
          cancelConfirmation: "Êtes-vous sûr de vouloir annuler ?",
          discardChanges: "Abandonner les modifications",
          stay: "Rester",
          discard: "Abandonner",
          close: "Fermer",
          ok: "Ok",
          errorProcessingRequest: "Erreur lors du traitement de la demande",
          errorProcessingRequestDescription: "Veuillez réessayer.",
          processing: "Traitement...",
          processingAudio: "Traitement de l'audio",
          minutesSaved: "Vous avez économisé",
          minutes: "minutes",
          savedIn: "en",
          audioSentCorrectly: "Audio envoyé correctement",
          retry: "Réessayer",
          dateTime: "Date et heure",
          duration: "Durée",
          disposition: "Résultat",
          busy: "Occupé",
          connected: "Connecté",
          noResponse: "Pas de réponse",
          wrongNumber: "Numéro incorrect",
          voiceMessage: "Message vocal laissé",
          liveMessage: "Message en direct laissé",
          direction: "Direction",
          inbound: "ENTRANT",
          outbound: "SORTANT",
          title: "Titre",
          audioText: "Appuyez pour enregistrer",
          description: "Description",
          associations: "Associations",
          companies: "Entreprises",
          deals: "Affaires",
          companyName: "Nom de l'entreprise",
          companyDomain: "Domaine de l'entreprise",
          selectCompany: "Sélectionnez une entreprise",
          createCompany: "Créer une entreprise",
          createCompanyDescription: "Créez une nouvelle entreprise",
          userAlreadyExists: "Une erreur s'est produite, veuillez vérifier les données et réessayer",
          name: "Nom",
          lastName: "Nom de famille",
          email: "Email",
          phoneNumber: "Téléphone",
          selectContact: "Sélectionnez un contact",
          createContact: "Créer un contact",
          dealName: "Nom de l'affaire",
          dealValue: "Valeur de l'affaire",
          dealClose: "Date de clôture de l'affaire",
          selectDeal: "Sélectionnez une affaire",
          recipients: "Destinataires",
          addRecipient: "Ajouter un destinataire",
          attachments: "Pièces jointes",
          uploadAttachment: "Téléverser un fichier",
          uploadingAttachment: "Téléversement du fichier...",
          recentAttachments: "Fichiers récents",
          noRecentAttachments: "Aucun fichier récent",
          attachmentUploadFailed: "Impossible de téléverser la pièce jointe",
          emailInvalidHint: "Email invalide. Transcription : '{{value}}'. Modifiez pour corriger.",
          subject: "Sujet",
          message: "Message",
          meetingTitle: "Titre de la réunion",
          meetingStartDate: "Date de début",
          meetingEndDate: "Date de fin",
          meetingLocation: "Lieu",
          meetingReminder: "Rappel",
          meetingDescription: "Description",
          meetingInternalNote: "Note interne",
          low: "Basse",
          medium: "Moyenne",
          high: "Haute",
          dueDate: "Date d'échéance",
          hsTaskType: "Type de tâche",
          call: "Appel",
          email: "Courriel",
          todo: "Tâche",
          crmUpdated: "CRM mis à jour correctement",
          domain: "Domaine",
          phone: "Téléphone",
          address: "Adresse",
          audioCompanyText: "Appuyez pour enregistrer des actions sur cette entreprise",
          errorMovingDeal: "Erreur lors du déplacement de l'affaire. Veuillez réessayer plus tard.",
          selectStage: "Sélectionnez l'étape du pipeline vers laquelle vous souhaitez déplacer cette affaire.",
          moveDeal: "Déplacer vers une autre étape",
          dealMoved: "Affaire déplacée avec succès",
          noDealsFound: "Aucune affaire trouvée",
          kanban: "Kanban",
          closingSoon: "Bientôt",
          noDealsInStage: "—",
          noContactsFound: "Aucun contact trouvé",
          noCompaniesFound: "Aucune entreprise trouvée",
          noTasksFound: "Aucune tâche trouvée",
          filterPipeline: "Filtrer par pipeline",
          save: "Enregistrer",
          stage: "Étape",
          amount: "Montant",
          closedate: "Date de clôture",
          createdate: "Date de création",
          audioContactText: "Parle : édite des champs, associe une entreprise, crée tâches, notes, deals, emails, appels ou réunions",
          record: "Enregistrer",
          account: "Compte",
          recording: "Enregistrement audio en cours...",
          paused: "En pause",
          microphone: "Microphone",
          recordingCancelled: "Enregistrement annulé",
          clearRecording: "Effacer l'enregistrement",
          resumeRecording: "Reprendre l'enregistrement",
          selectMicrophone: "Sélectionner le microphone",
          recordAgain: "Enregistrer de nouveau",
          cancel: "Annuler",
          close: "Fermer",
          done: "Terminé",
          search: "Rechercher",
          min: "min",
          sortBy: "Trier par",
          newest: "Plus récent",
          oldest: "Plus ancien",
          disconnectGmail: "Déconnecter Gmail",
          logout: "Se déconnecter",
          connectGmail: "Connecter Gmail",
          gmailConnected: "Gmail connecté correctement",
          gmailDisconnected: "Gmail déconnecté correctement",
          attendees: "Participants",
          properties: "Propriétés",
          select_properties: "Sélectionnez les propriétés",
          propertyToUpdate: "Propriété à mettre à jour",
          selectProperty: "Sélectionnez les propriétés",
          updateProperties: "Mettre à jour les propriétés",
          propertiesUpdated: "Propriétés mises à jour correctement",
          propertiesUpdatedError: "Erreur lors de la mise à jour des propriétés",
          objectType: "Type d'objet",
          selectProperties: "Sélectionnez les propriétés",
          search_properties: "Rechercher des propriétés",
          noPropertiesSelected: "Aucune propriété sélectionnée pour la configuration.",
          configureProperties: "Configurer les propriétés",
          mandatory: "Obligatoire",
          mandatoryIf: "Obligatoire si",
          globalProperties: "Propriétés globales de l'affaire",
          stageProperties: "Propriétés de l'étape",
          loadingProperties: "Chargement des propriétés...",
          currentStage: "Étape actuelle",
          selectPipelineForProps: "Pipeline",
          selectStageForProps: "Étape",
          selectPipelineFirst: "Sélectionnez d'abord un pipeline",
          selectStageFirst: "Sélectionnez une étape pour configurer les propriétés spécifiques",
          remove: "Supprimer",
          createGoogleMeet: "Envoyer le lien Google Meet",
          createMeeting: "Envoyer l'invitation de réunion au client",
          completed: "Terminé",
          not_started: "Non commencé",
          none: "Sans priorité",
          reminders: "Rappels",
          nearest: "Plus proche",
          farthest: "Plus éloigné",
          updateTask: "Mettre à jour la tâche",
          status: "Statut",
          notStarted: "Non commencé",
          inProgress: "En cours",
          errorUpdatingTask: "Erreur lors de la mise à jour de la tâche",
          priority: "Priorité",
          type: "Type",
          identifyingActions: "Identification des actions",
          welcomeToLabia: "Bienvenue sur Labia",
          onboardingDescription: "Découvrez ce que vous pouvez faire avec Labia à travers ces exemples. Cliquez sur 'Essayer' pour voir comment cela fonctionne !",
          onboardingExamplesCarousel: "Exemples d'intégration",
          slideXofY: "Diapositive {{current}} sur {{total}}",
          goToSlide: "Aller à la diapositive {{number}}",
          previousSlide: "Diapositive précédente",
          nextSlide: "Diapositive suivante",
          example: "Exemple",
          tryIt: "Essayer",
          showMore: "Afficher plus",
          showLess: "Afficher moins",
          learnToUseLabia: "Découvrez ce que vous pouvez faire avec Labia",
          discoverLabia: "Découvrez ce que vous pouvez faire",
          onboarding: "Voulez-vous apprendre à utiliser Labia ?",
          onboardingExamples: {
            contactAndCompany: {
              title: "Créer des Contacts et des Entreprises",
              description: "Créez facilement de nouveaux contacts et entreprises avec tous leurs détails en langage naturel.",
              example: "Labia, créez un contact nommé Daniel Rodriguez de l'entreprise Labia avec l'email dani@labia.pro et le téléphone 678368027. Créez l'entreprise Labia avec le domaine labia.pro",
            },
            dealsPipeline: {
              title: "Créer des Affaires dans le pipeline de vente",
              description: "Créez des affaires dans le pipeline de vente pour suivre les informations importantes.",
              example: "Créez une affaire d'une valeur de 5000 euros avec le nom \"Pack 100 unités\" et une date de clôture estimée au 20 juin.",
            },
            tasksAndNotes: {
              title: "Créer des Tâches et des Notes",
              description: "Planifiez des tâches et ajoutez des notes pour suivre les informations importantes et conclure plus de ventes.",
              example: "Recherchez le contact Daniel Rodríguez et créez une tâche pour l'appeler vendredi à 10 heures du matin pour vérifier s'il a pu voir notre catalogue et notre offre. Créez également une note interne expliquant qu'il est le directeur des achats, qu'il est cœliaque et qu'il supporte le Real Madrid."
            },
            email: {
              title: "Envoyer des emails",
              description: "Envoyez des Emails personalisés avec le ton de votre entreprise",
              example: "Envoyez un email à Daniel Rodríguez avec un ton enthousiaste disant que j'ai déjà essayé Labia, que je l'ai trouvé incroyable et qu'il me fera gagner beaucoup de temps, ajoutez des icônes."
            },
            meeting: {
              title: "Planifier des réunions",
              description: "Planifiez des réunions avec les clients et envoyez-leur l'invitation",
              example: "Planifiez une réunion avec Daniel Rodríguez pour le 15 juin à 12h dans ses bureaux de Madrid avec l'Objet : \"Réunion Démo\", où nous parlerons de notre nouveau produit."
            },
            call: {
              title: "Appels",
              description: "Enregistrez les appels avec le résumé de ce qui a été discuté avec le client",
              example: "Enregistrez un appel avec le contact Daniel Rodríguez il y a 10 minutes où nous avons parlé du devis que la concurrence lui a envoyé et il m'a dit que s'il obtient une réduction de 10%, il signera cet après-midi."
            },
            allInOne: {
              title: "Toutes les actions en une seule instruction",
              description: "Créez un contact, une tâche, une note et un email avec une seule instruction.",
              example: "Créez un contact nommé Carmen Rodriguez Pérez de l'entreprise CRM avec l'email carmen@crm.com et le téléphone 611223344. Créez l'entreprise CRM avec le domaine CRM.com\n\nCréez une tâche pour l'appeler vendredi à 10 heures du matin et lui dire que j'ai déjà augmenté mes ventes grâce à la meilleure gestion du CRM.\n\nCréez également une note interne du contact expliquant qu'elle est la directrice de l'entreprise et qu'elle est chargée de recevoir les suggestions des clients.\n\nEnfin, envoyez-lui un email avec un ton enthousiaste disant que j'ai déjà essayé son outil, que je l'ai trouvé incroyable et qu'il me fera gagner beaucoup de temps, ajoutez des icônes."
            }
          },
          audioHistory: "Historique audio",
          audioStatusEmpty: "Sans transcription",
          audioStatusDraft: "Non exécuté",
          loading: "Chargement...",
          noAudioHistory: "Aucun historique audio disponible",
          selectCamera: "Sélectionner la caméra",
          capturePhoto: "Capturer la photo",
          capturing: "Capturé...",
          errorProcessingPhoto: "Erreur lors du traitement de la photo",
          ocrResult: "Texte détecté",
          ocr: "Scanner le document",
          businessCard: "Scanner la carte de visite",
          errorPageTitle: "Une erreur est survenue",
          errorPageDescription: "Une erreur inattendue s'est produite. Vous pouvez revenir à l'accueil ou essayer de recharger la page.",
          errorPageNotFound: "Page non trouvée",
          errorPageNotFoundDescription: "La page que vous recherchez n'existe pas ou a été déplacée.",
          errorPageGoHome: "Retour à l'accueil",
          validationStepError: "Cette étape n'a pas pu être chargée. Vous pouvez la passer et continuer le processus.",
          skipStep: "Passer cette étape",
          requiredFields: "Champs obligatoires",
          optionalFields: "Facultatifs",
          required: "Obligatoire",
          step: "étape",
          endBeforeStart: "La date de fin est antérieure à la date de début",
          newContact: "Nouveau contact",
          existingContact: "Contact existant",
          editing: "Édition",
          saveChanges: "Enregistrer les modifications",
          selectExisting: "Sélectionner existant",
          createNew: "Créer nouveau",
          contactModeEdit: "Modifier",
          contactModeCreate: "Créer",
          contactModeSelect: "Sélectionner",
          contactModeEditHelp: "Vous mettrez à jour les données de {{name}} dans HubSpot",
          contactModeCreateHelp: "Un nouveau contact sera créé",
          contactModeSelectHelp: "Lié à {{name}} sans modifier ses données",
          newCompany: "Nouvelle entreprise",
          existingCompany: "Entreprise existante",
          meetingDate: "Date",
          startTime: "Heure de début",
          meetingDuration: "Durée",
          endsAt: "Se termine à",
          durationMinutes: "Durée (min)",
          mandatoryField: "Champ obligatoire",
          list: "Liste",
          calendar: "Calendrier",
          tapToSelect: "Appuyez pour sélectionner",
          deselect: "Désélectionner",
          filters: "Filtres",
          dayView: "Jour",
          weekView: "Semaine",
          monthView: "Mois",
          noTasksOnDay: "Aucune tâche ce jour",
          noPriority: "Sans priorité",
          goBack: "Retour",
          all: "Tout",
          dueToday: "Échéance aujourd'hui",
          overdue: "En retard",
          week: "Semaine",
          month: "Mois",
          noDate: "Sans date",
          today: "Aujourd'hui",
          tomorrow: "Demain",
          yesterday: "Hier",
          selected: "sélec.",
          selectAll: "Tout sélec.",
          dateRange: "Filtre de date",
          complete: "Terminer",
          markComplete: "Terminer",
          reschedule: "Reprogrammer",
          rescheduleDescription: "Sélectionnez la nouvelle date",
          rescheduleTaskDescription: "Sélectionnez la nouvelle date pour cette tâche",
          newDate: "Nouvelle date",
          tasksUpdated: "Tâches mises à jour",
          taskUpdated: "Tâche mise à jour",
          overdueTask: "En retard",
          updateTaskDescription: "Mettez à jour les détails de la tâche",
          errorSavingProperties: "Erreur lors de l'enregistrement des propriétés. Veuillez réessayer.",
          selectPipelineAndStageFirst: "Sélectionnez d'abord un pipeline et une étape",
          noneCondition: "Aucune condition",
          propertiesIntroTitle: "Configurez ce que l'IA extrait de votre voix",
          propertiesIntroDescription: "Sélectionnez les propriétés CRM que l'IA doit remplir quand vous parlez. Marquez les obligatoires pour toujours demander confirmation.",
          propertiesIntroTip: "Conseil : Utilisez « Obligatoire si » pour lier des champs. Par exemple, rendez « Ville » obligatoire uniquement si « Adresse » est présent.",
          gotIt: "Compris",
          propertyType: "Type",
          propertiesEmptyHint: "Cherchez et ajoutez des propriétés avec le champ ci-dessus.",
          stageEmptyHint: "Sélectionnez un pipeline et une étape ci-dessus pour configurer les propriétés spécifiques.",
          voiceUpdate: "Mise à jour vocale",
          additionalDetails: "Détails supplémentaires",
          audioDealText: "Appuyez pour mettre à jour cette affaire",
          contactInfo: "Informations",
          sendEmail: "Email",
          callContact: "Appeler",
          audioEmailText: "Dictez l'e-mail que vous souhaitez envoyer",
          industry: "Industrie",
          employees: "Employés",
          annualRevenue: "Revenu annuel",
          associatedContacts: "Contacts associés",
          associatedDeals: "Affaires associées",
          noAssociatedContacts: "Aucun contact associé",
          noAssociatedDeals: "Aucune affaire associée",
          companyInfo: "Informations de l'entreprise",
          selectAssociations: "Associer des entités",
          missingAssociations: "Sélectionnez des contacts ou entreprises à associer",
          resend: "Renvoyer",
          edit: "Modifier",
          tryExampleHint: "Essayez de dire quelque chose comme...",
          almostReady: "Presque prêt...",
          createdSuccessfully: "Créé avec succès !",
          recordAnother: "Enregistrer un autre",
          review: "Revue",
          actionsToCreate: "{{count}} actions seront créées",
          confirmAndSend: "Confirmer et envoyer",
          addAction: "Ajouter une action",
          speakToAddMore: "Parlez pour en ajouter",
          draftFound: "Brouillon trouvé",
          resumeDraft: "Reprendre",
          discardDraft: "Supprimer",
          liveTranscript: "Transcription en direct",
          followUpWith: "Suivi avec {{name}}",
          associationsPreview: "Associations",
          willBeLinked: "sera lié à",
          flowContact: "Contact du flux",
          flowCompany: "Entreprise du flux",
          expressMode: "Express",
          expressDescription: "Valide tout avant la révision",
          oneShotSuccess: "Données extraites correctement. Vérifiez et confirmez.",
          estimatedCloseDate: "Date de clôture estimée",
          dealOwner: "Responsable de l'affaire",
          firstName: "Prénom",
          taskType: "Type de tâche",
          startDate: "Date de début",
          endTime: "Heure de fin",
          location: "Lieu",
          internalNote: "Note interne",
          emailSubject: "Objet de l'e-mail",
          emailMessage: "Message de l'e-mail",
          sender: "Expéditeur",
          callTitle: "Titre de l'appel",
          date: "Date",
          details: "Détails",
          internalNotes: "Notes internes",
          createCalendarEvent: "Créer un événement de calendrier",
          validatingData: "Validation des données...",
          validating: "Validation de",
          analyzingContent: "Analyse du contenu",
          extractingEntities: "Extraction des entités",
          searchingCRM: "Recherche dans le CRM",
          processingComplete: "Traitement terminé",
          propertyAssistant: "Assistant IA",
          propertyChatTitle: "Configurer les propriétés",
          propertyChatWelcome: "Je suis votre assistant de configuration des propriétés CRM. Décrivez votre activité et je vous recommanderai quels champs configurer comme obligatoires pour chaque type d'objet (contacts, affaires, tâches, etc.). Vous pouvez aussi utiliser l'onglet Manuel pour configurer directement.",
          propertyChatDailyIntroBadge: "Intro IA du jour",
          propertyChatDailyIntroToday: "Mis à jour aujourd'hui pour votre entreprise",
          propertyChatDailyIntroCached: "Réutilisation du contexte précédent de votre entreprise",
          propertyChatPlaceholder: "Décrivez votre activité ou posez une question sur les propriétés...",
          chatPrompt1: "Agence immobilière",
          chatPrompt2: "Startup SaaS, ventes B2B",
          chatPrompt3: "Cabinet de conseil en services",
          applyConfiguration: "Appliquer",
          modifyConfiguration: "Modifier",
          applying: "Application en cours...",
          configTimeout: "Délai dépassé. Réessayez.",
          configApplied: "Configuration appliquée avec succès",
          configFailed: "Erreur lors de l'application de la configuration",
          aiSuggestion: "Suggestion IA",
          propertiesFor: "propriétés",
          propertySingular: "propriété",
          propertyPlural: "propriétés",
          deal_stage: "étape de l'affaire",
          mandatoryBadge: "Obligatoire",
          optionalBadge: "Optionnel",
          conditional: "Conditionnel",
          chatTab: "Assistant IA",
          manualTab: "Manuel",
          addProperty: "Ajouter une propriété",
          searchAndAddProperty: "Rechercher et ajouter une propriété...",
          propertyType_string: "Texte",
          propertyType_number: "Nombre",
          propertyType_date: "Date",
          propertyType_datetime: "Date/Heure",
          propertyType_enumeration: "Liste",
          propertyType_bool: "Oui/Non",
          propertyType_phone_number: "Téléphone",
          saveProperties: "Enregistrer",
          selectObjectType: "Sélectionner le type d'objet",
          companyProfile: "Profil d'entreprise",
          writingTone: "Ton d'écriture",
          configureInAssistant: "Configurer dans l'Assistant IA →",
          writingStyle: "Style d'écriture",
          trainedOnEmails: "Entraîné avec {{count}} e-mails",
          autoUpdates: "Se met à jour automatiquement avec chaque e-mail envoyé",
          profileUpdated: "Profil mis à jour"
        }
      },
      en: {
        translation: {
          noCreditsLeft: "No credits available",
          login: "Login",
          sendingData: "Sending data",
          notObjectProcessed: "The following objects could not be processed:\n",
          company: "Company",
          contact: "Contact",
          deal: "Deal",
          task: "Task",
          meeting: "Meeting",
          mail: "Mail",
          contacts: "Contacts",
          note: "Note",
          call: "Call",
          pipeline: "Pipeline",
          pipelineStages: "Stages",
          other: "Other",
          selectPipeline: "Select a pipeline",
          selectPipelineStage: "Select a stage",
          validateCompany: "Validate company data",
          validateContact: "Validate contact data",
          validateTask: "Validate task data",
          validateMeeting: "Validate meeting data",
          validateMail: "Validate mail data",
          validateNote: "Validate note data",
          validateCall: "Validate call data",
          validateDeal: "Validate deal data",
          validateEmail: "Validate email data",
          voiceInput: "Voice input",
          stopRecording: "Stop recording",
          voiceProcessing: "Processing voice...",
          voiceError: "Recording error",
          makeShorter: "Shorter",
          makeProfessional: "Professional",
          addUrgency: "Urgent",
          makeFriendly: "Friendly",
          tasks: "Tasks",
          next: "Next",
          finish: "Finish",
          cancel: "Cancel",
          cancelConfirmation: "Are you sure you want to cancel?",
          discardChanges: "Discard changes",
          stay: "Stay",
          discard: "Discard",
          close: "Close",
          ok: "Ok",
          errorProcessingRequest: "Error processing request",
          errorProcessingRequestDescription: "Please try again.",
          processing: "Processing...",
          processingAudio: "Processing audio",
          minutesSaved: "You saved",
          minutes: "minutes",
          savedIn: "in",
          audioSentCorrectly: "Audio sent successfully",
          retry: "Retry",
          dateTime: "Date and time",
          duration: "Duration",
          disposition: "Result",
          busy: "Busy",
          connected: "Connected",
          noResponse: "No response",
          wrongNumber: "Wrong number",
          voiceMessage: "Left voicemail",
          liveMessage: "Left live message",
          direction: "Direction",
          inbound: "INBOUND",
          outbound: "OUTBOUND",
          title: "Title",
          audioText: "Press to record",
          description: "Description",
          associations: "Associations",
          companies: "Companies",
          deals: "Deals",
          companyName: "Company name",
          companyDomain: "Company domain",
          selectCompany: "Select a company",
          createCompany: "Create company",
          errorSendingAudio: "Error sending audio",
          createCompanyDescription: "Create a new company",
          userAlreadyExists: "An error occurred, please check the data and try again",
          name: "Name",
          lastName: "Last name",
          email: "Email",
          phoneNumber: "Phone number",
          selectContact: "Select a contact",
          createContact: "Create contact",
          dealName: "Deal name",
          dealValue: "Deal value",
          dealClose: "Deal closing date",
          selectDeal: "Select a deal",
          recipients: "Recipients",
          addRecipient: "Add recipient",
          attachments: "Attachments",
          uploadAttachment: "Upload file",
          uploadingAttachment: "Uploading file...",
          recentAttachments: "Recent files",
          noRecentAttachments: "No recent files",
          attachmentUploadFailed: "Unable to upload attachment",
          emailInvalidHint: "Invalid email. Transcript: '{{value}}'. Edit to fix it.",
          subject: "Subject",
          message: "Message",
          meetingTitle: "Meeting title",
          meetingStartDate: "Start date",
          meetingEndDate: "End date",
          meetingLocation: "Location",
          meetingReminder: "Reminder",
          meetingDescription: "Description",
          meetingInternalNote: "Internal note",
          low: "Low",
          medium: "Medium",
          high: "High",
          dueDate: "Due date",
          hsTaskType: "Task type",
          call: "Call",
          email: "Email",
          todo: "Task",
          crmUpdated: "CRM updated successfully",
          domain: "Domain",
          phone: "Phone",
          address: "Address",
          audioCompanyText: "Press to record actions about this company",
          errorMovingDeal: "Error moving deal. Please try again later.",
          selectStage: "Select which pipeline stage you want to move this deal to.",
          moveDeal: "Move to another stage",
          dealMoved: "Deal moved successfully",
          noDealsFound: "No deals found",
          kanban: "Kanban",
          closingSoon: "Closing soon",
          noDealsInStage: "—",
          noContactsFound: "No contacts found",
          noCompaniesFound: "No companies found",
          noTasksFound: "No tasks found",
          filterPipeline: "Filter by pipeline",
          save: "Save",
          stage: "Stage",
          amount: "Amount",
          closedate: "Closing date",
          createdate: "Creation date",
          audioContactText: "Speak: edit fields, link a company, create tasks, notes, deals, emails, calls or meetings",
          record: "Record",
          account: "Account",
          recording: "Recording audio...",
          paused: "Paused",
          microphone: "Microphone",
          recordingCancelled: "Recording cancelled",
          clearRecording: "Clear recording",
          resumeRecording: "Resume recording",
          selectMicrophone: "Select microphone",
          recordAgain: "Record again",
          cancel: "Cancel",
          close: "Close",
          done: "Done",
          search: "Search",
          min: "min",
          sortBy: "Sort by",
          newest: "Newest",
          oldest: "Oldest",
          disconnectGmail: "Disconnect Gmail",
          logout: "Logout",
          connectGmail: "Connect Gmail",
          gmailConnected: "Gmail connected successfully",
          gmailDisconnected: "Gmail disconnected successfully",
          attendees: "Attendees",
          properties: "Properties",
          select_properties: "Select properties",
          propertyToUpdate: "Property to update",
          selectProperty: "Select properties",
          updateProperties: "Update properties",
          propertiesUpdated: "Properties updated successfully",
          propertiesUpdatedError: "Error updating properties",
          objectType: "Object Type",
          selectProperties: "Select Properties",
          search_properties: "Search properties",
          noPropertiesSelected: "No properties selected to configure.",
          configureProperties: "Configure Properties",
          mandatory: "Mandatory",
          mandatoryIf: "Mandatory if",
          globalProperties: "Global deal properties",
          stageProperties: "Stage properties",
          loadingProperties: "Loading properties...",
          currentStage: "Current stage",
          selectPipelineForProps: "Pipeline",
          selectStageForProps: "Stage",
          selectPipelineFirst: "Select a pipeline first",
          selectStageFirst: "Select a stage to configure stage-specific properties",
          remove: "Remove",
          createGoogleMeet: "Send Google Meet link",
          createMeeting: "Send meeting invitation to client",
          completed: "Completed",
          not_started: "Not started",
          none: "No priority",
          reminders: "Reminders",
          nearest: "Nearest",
          farthest: "Farthest",
          updateTask: "Update task",
          status: "Status",
          notStarted: "Not started",
          inProgress: "In progress",
          errorUpdatingTask: "Error updating task",
          priority: "Priority",
          type: "Type",
          identifyingActions: "Identifying actions",
          welcomeToLabia: "Welcome to Labia",
          onboardingDescription: "Discover what you can do with Labia through these examples. Click 'Try it' to see how it works!",
          onboardingExamplesCarousel: "Onboarding examples",
          slideXofY: "Slide {{current}} of {{total}}",
          goToSlide: "Go to slide {{number}}",
          previousSlide: "Previous slide",
          nextSlide: "Next slide",
          example: "Example",
          tryIt: "Try it",
          showMore: "Show more",
          showLess: "Show less",
          learnToUseLabia: "Discover what you can do with Labia",
          discoverLabia: "Discover what you can do",
          onboarding: "Want to learn how to use Labia?",
          onboardingExamples: {
            contactAndCompany: {
              title: "Create Contacts and Companies",
              description: "Easily create new contacts and companies with all their details in natural language.",
              example: "Labia, create a contact named Daniel Rodriguez from the company Labia with email dani@labia.pro and phone 678368027. Create the company Labia with domain labia.pro",
            },
            dealsPipeline: {
              title: "Create Deals in the sales pipeline",
              description: "Create deals in the sales pipeline to track important information.",
              example: "Create a deal worth 5000 euros named \"Package 100 units\" with an estimated closing date of June 20th.",
            },
            tasksAndNotes: {
              title: "Create Tasks and Notes",
              description: "Schedule tasks and add notes to track important information and close more sales.",
              example: "Find contact Daniel Rodríguez and create a task to call him on Friday at 10 AM to check if he has been able to see our catalog and our offer. Also create an internal note stating that he is the purchasing director, is celiac, and supports Real Madrid."
            },
            email: {
              title: "Send emails",
              description: "Send personalized Emails with your company's tone",
              example: "Send an email to Daniel Rodríguez with an excited tone saying that I've already tried Labia, found it amazing and it will save me a lot of time, add icons."
            },
            meeting: {
              title: "Schedule meetings",
              description: "Schedule meetings with clients and send them the meeting invitation",
              example: "Schedule a meeting with Daniel Rodríguez for June 15th at 12 PM at his office in Madrid with the Subject: \"Demo Meeting\", where we will talk about our new product."
            },
            call: {
              title: "Calls",
              description: "Record calls with the summary of what was discussed with the client",
              example: "Record a call with contact Daniel Rodríguez 10 minutes ago where we talked about the quote that the competition sent him and he told me that if we give him a 10% discount he will sign it this afternoon."
            },
            allInOne: {
              title: "All actions in a single instruction",
              description: "Create a contact, task, note, and email with a single instruction.",
              example: "Create a contact named Carmen Rodriguez Pérez from the company CRM with email carmen@crm.com and phone 611223344. Create the company CRM with domain CRM.com\n\nCreate a task to call her on Friday at 10 AM and tell her that I've already increased my sales thanks to better CRM management.\n\nAlso create an internal note about the contact explaining that she is the company director and is in charge of receiving customer suggestions.\n\nFinally, send her an email with an excited tone saying that I've already tried her tool, found it amazing and it will save me a lot of time, add icons."
            }
          },
          audioHistory: "Audio history",
          audioStatusEmpty: "No transcription",
          audioStatusDraft: "Not executed",
          loading: "Loading...",
          noAudioHistory: "No audio history available",
          selectCamera: "Select camera",
          capturePhoto: "Capture photo",
          capturing: "Capturing...",
          errorProcessingPhoto: "Error processing photo",
          ocrResult: "Detected text",
          ocr: "Scan document",
          businessCard: "Scan business card",
          errorPageTitle: "Something went wrong",
          errorPageDescription: "An unexpected error occurred. You can go back to the home page or try reloading.",
          errorPageNotFound: "Page not found",
          errorPageNotFoundDescription: "The page you're looking for doesn't exist or has been moved.",
          errorPageGoHome: "Go to home",
          validationStepError: "This step could not be loaded. You can skip it and continue with the rest of the process.",
          skipStep: "Skip this step",
          requiredFields: "Required fields",
          optionalFields: "Optional",
          required: "Required",
          step: "step",
          endBeforeStart: "End date is before the start date",
          newContact: "New contact",
          existingContact: "Existing contact",
          editing: "Editing",
          saveChanges: "Save changes",
          selectExisting: "Select existing",
          createNew: "Create new",
          contactModeEdit: "Edit",
          contactModeCreate: "Create",
          contactModeSelect: "Select",
          contactModeEditHelp: "You will update {{name}}'s data in HubSpot",
          contactModeCreateHelp: "A new contact will be created",
          contactModeSelectHelp: "Linked to {{name}} without changing their data",
          newCompany: "New company",
          existingCompany: "Existing company",
          meetingDate: "Date",
          startTime: "Start time",
          meetingDuration: "Duration",
          endsAt: "Ends at",
          durationMinutes: "Duration (min)",
          mandatoryField: "Required field",
          list: "List",
          calendar: "Calendar",
          tapToSelect: "Tap to select",
          deselect: "Deselect",
          filters: "Filters",
          dayView: "Day",
          weekView: "Week",
          monthView: "Month",
          noTasksOnDay: "No tasks on this day",
          noPriority: "No priority",
          goBack: "Go back",
          all: "All",
          dueToday: "Due today",
          overdue: "Overdue",
          week: "Week",
          month: "Month",
          noDate: "No date",
          today: "Today",
          tomorrow: "Tomorrow",
          yesterday: "Yesterday",
          selected: "selected",
          selectAll: "Select all",
          dateRange: "Date range filter",
          complete: "Complete",
          markComplete: "Complete",
          reschedule: "Reschedule",
          rescheduleDescription: "Select the new date",
          rescheduleTaskDescription: "Select the new date for this task",
          newDate: "New date",
          tasksUpdated: "Tasks updated",
          taskUpdated: "Task updated",
          overdueTask: "Overdue",
          updateTaskDescription: "Update the task details",
          errorSavingProperties: "Error saving properties. Please try again.",
          selectPipelineAndStageFirst: "Select a pipeline and stage first",
          noneCondition: "No condition",
          propertiesIntroTitle: "Configure what the AI extracts from your voice",
          propertiesIntroDescription: "Select which CRM properties the AI should fill when you speak. Mark properties as mandatory to always require confirmation.",
          propertiesIntroTip: "Tip: Use \"Mandatory if\" to link related fields. For example, make \"City\" mandatory only when \"Address\" is present.",
          gotIt: "Got it",
          propertyType: "Type",
          propertiesEmptyHint: "Search and add properties using the field above.",
          stageEmptyHint: "Select a pipeline and stage above to configure stage-specific properties.",
          voiceUpdate: "Voice update",
          additionalDetails: "Additional details",
          audioDealText: "Tap to update this deal",
          contactInfo: "Information",
          sendEmail: "Email",
          callContact: "Call",
          audioEmailText: "Dictate the email you want to send",
          industry: "Industry",
          employees: "Employees",
          annualRevenue: "Annual revenue",
          associatedContacts: "Associated contacts",
          associatedDeals: "Associated deals",
          noAssociatedContacts: "No associated contacts",
          noAssociatedDeals: "No associated deals",
          companyInfo: "Company info",
          selectAssociations: "Associate entities",
          missingAssociations: "Select contacts or companies to associate",
          resend: "Resend",
          edit: "Edit",
          tryExampleHint: "Try saying something like...",
          almostReady: "Almost ready...",
          createdSuccessfully: "Created successfully!",
          recordAnother: "Record another",
          review: "Review",
          actionsToCreate: "{{count}} actions will be created",
          confirmAndSend: "Confirm & Send",
          addAction: "Add action",
          speakToAddMore: "Speak to add more",
          draftFound: "Unsaved draft found",
          resumeDraft: "Resume",
          discardDraft: "Discard",
          liveTranscript: "Live transcript",
          followUpWith: "Follow up with {{name}}",
          associationsPreview: "Associations",
          willBeLinked: "will be linked to",
          flowContact: "Flow contact",
          flowCompany: "Flow company",
          expressMode: "Express",
          expressDescription: "Validates everything before review",
          oneShotSuccess: "All data extracted correctly. Review and confirm.",
          estimatedCloseDate: "Estimated close date",
          dealOwner: "Deal owner",
          firstName: "First name",
          taskType: "Task type",
          startDate: "Start date",
          endTime: "End time",
          location: "Location",
          internalNote: "Internal note",
          emailSubject: "Email subject",
          emailMessage: "Email message",
          sender: "Sender",
          callTitle: "Call title",
          date: "Date",
          details: "Details",
          internalNotes: "Internal notes",
          createCalendarEvent: "Create calendar event",
          validatingData: "Validating data...",
          validating: "Validating",
          analyzingContent: "Analyzing content",
          extractingEntities: "Extracting entities",
          searchingCRM: "Searching CRM",
          processingComplete: "Processing complete",
          propertyAssistant: "AI Assistant",
          propertyChatTitle: "Configure properties",
          propertyChatWelcome: "I'm your CRM property configuration assistant. Describe your business and I'll recommend which fields to make mandatory for each object type (contacts, deals, tasks, etc.). You can also use the Manual tab to configure directly.",
          propertyChatDailyIntroBadge: "Daily AI intro",
          propertyChatDailyIntroToday: "Updated today for your company",
          propertyChatDailyIntroCached: "Reusing your company's previous context",
          propertyChatPlaceholder: "Describe your business or ask about properties...",
          chatPrompt1: "Real estate agency",
          chatPrompt2: "SaaS startup, B2B sales",
          chatPrompt3: "Professional services firm",
          applyConfiguration: "Apply",
          modifyConfiguration: "Modify",
          applying: "Applying...",
          configTimeout: "Request timed out. Retry.",
          configApplied: "Configuration applied successfully",
          configFailed: "Error applying configuration",
          aiSuggestion: "AI Suggestion",
          propertiesFor: "properties",
          propertySingular: "property",
          propertyPlural: "properties",
          deal_stage: "deal stage",
          mandatoryBadge: "Required",
          optionalBadge: "Optional",
          conditional: "Conditional",
          chatTab: "AI Assistant",
          manualTab: "Manual",
          addProperty: "Add property",
          searchAndAddProperty: "Search and add property...",
          propertyType_string: "Text",
          propertyType_number: "Number",
          propertyType_date: "Date",
          propertyType_datetime: "DateTime",
          propertyType_enumeration: "Enum",
          propertyType_bool: "Boolean",
          propertyType_phone_number: "Phone",
          saveProperties: "Save",
          selectObjectType: "Select object type",
          companyProfile: "Company profile",
          writingTone: "Writing tone",
          configureInAssistant: "Configure in AI Assistant →",
          writingStyle: "Writing style",
          trainedOnEmails: "Trained on {{count}} emails",
          autoUpdates: "Auto-updates with every sent email",
          profileUpdated: "Profile updated"
        }
      }
    }
  });

export function getLanguage() {
  return i18n.language.split('-')[0]; // Returns just the ISO-639-1 part (e.g. 'es' from 'es-ES')
}

export default i18n;